import { demoVideo } from '../../../video.mjs';
import { config } from '../../config';
import { client } from '../content/client';
import { CopyText } from '../lib/marks';
import { siteEnv } from '../lib/siteEnv';
import { useHydrated } from '../lib/useHydrated';
import { CtaLink, Section } from '../pages/layout';
import s from '../site.module.css';

/**
 * The client page's demo video section. The prerender uses the build's PAIRING_DEMO_VIDEO_URL; once hydrated, the
 * deployed runtime value (window.__PAIRING_CONFIG__.demoVideoUrl) wins. With neither, the whole section is left out.
 */
export function DemoVideoSection() {
  const v = client.video;
  const hydrated = useHydrated();
  const video = demoVideo((hydrated && config.demoVideoUrl) || siteEnv.demoVideoUrl);
  if (!video) return null;

  return (
    <Section tone="sky" labelledBy="video-title">
      <div className={`${s.split} ${s.splitVideo}`}>
        <div className={s.stack}>
          <h2 id="video-title">{v.headline}</h2>
          <CopyText copy={v.body} className={s.lede} />
          <ol className={s.miniSteps}>
            {v.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
          <div className={s.stack}>
            <p className={s.promptLine}>{v.prompt}</p>
            <div className={s.ctaRow}>
              <CtaLink cta={v.cta} primary />
            </div>
          </div>
        </div>
        <div className={s.videoFrame}>
          {video.kind === 'embed' ? (
            <iframe
              src={video.src}
              title={v.title}
              loading="lazy"
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          ) : (
            <video src={video.src} controls preload="metadata" playsInline aria-label={v.title} />
          )}
        </div>
      </div>
    </Section>
  );
}
